import $ from 'jquery';

/**
 * @see vendor/sylius/sylius/src/Sylius/Bundle/ShopBundle/Resources/private/js/sylius-add-to-cart.js
 */
$.fn.extend({
    addToCart: function () {
        var element = $(this);
        var href = $(element).attr('action');
        var redirectUrl = $(element).data('redirect');
        var validationElement = $('#sylius-cart-validation-error');

        $(element).api({
            method: 'POST',
            on: 'submit',
            cache: false,
            url: href,
            beforeSend: function (settings) {
                settings.data = $(this).serialize();

                return settings;
            },
            onSuccess: function (response) {
                validationElement.addClass('hidden');
                window.location.replace(redirectUrl);
            },
            onFailure: function (response) {
                validationElement.removeClass('hidden');
                var validationMessage = '';

                if (!response.errors || !response.errors.errors) {
                    if (response.message) {
                        validationElement.html(response.message);
                        $(element).removeClass('loading');
                        return;
                    } else
                        console.log(response);
                }

                $.each(response.errors.errors, function (key, message) {
                    validationMessage += message;
                });
                validationElement.html(validationMessage);
                $(element).removeClass('loading');
            },
        });
    }
});
